<template>
  <div>
    <a-collapse v-model="data.collapseKey1" class="mb-16">
      <a-collapse-panel key="1">
        <div slot="header">
          <span>媒体和数据</span>
          <a-tooltip placement="topLeft" :title="chartType =='screen'?'请选择想要分析的媒体和数据层级':'默认继承整体的媒体和数据层级,可手动修改'" >
            <a-icon type="question-circle" class="ml-8"/>
          </a-tooltip>
        </div>
        <a-form-item label="媒体名称" class="mb-8">
          <a-select v-model="data.datasource" allowClear placeholder="请选择想要分析的媒体" @change="changeDataSource">
            <a-select-option
              v-for="item in dataSet"
              :key="item.mediaCode"
              :value="item.mediaCode"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="数据集" class="mb-8">
          <a-select v-model="data.tableId" allowClear placeholder="请选择想要分析的数据层级" @change="$emit('datachange')">
            <a-select-option
              v-for="item in tableList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-collapse-panel>
    </a-collapse>
    <a-collapse v-model="data.collapseKey2" class="mb-8">
      <a-collapse-panel key="1">
        <div slot="header">
          <template v-if="userInfo.innerFlag === 1">
            <span>客户和账号</span>
            <a-tooltip placement="topLeft" :title="chartType =='screen'?'请选择想要分析的财务ID或者账号,不选则默认为全部账号':'默认继承整体的财务ID和账号,可手动修改'" >
              <a-icon type="question-circle" class="ml-8"/>
            </a-tooltip>
          </template>
          <template v-else>
            <span>媒体账号</span>
            <a-tooltip placement="topLeft" :title="chartType =='screen'?'请选择想要分析的账号,不选则默认为全部':'默认继承整体的账号,可手动修改'" >
              <a-icon type="question-circle" class="ml-8"/>
            </a-tooltip>
          </template>
        </div>
        <a-form-item label="数据权限" class="mb-8">
          <a-select v-model="data.filterType" allowClear :placeholder="`请选择${ userInfo.innerFlag === 1?'财务ID或':'' }账号`" @change="changeDataDimensionType">
            <a-select-option
                v-for="item in dataDimensionOptionsNew"
                :key="item.value"
                :value="item.value"
              >
                {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-spin :spinning="loading"> -->
          <a-form-item :label="dataDimensionTypeName" class="mb-0 pb-0">
            <account-select 
              v-model="data.accountIds"
              @change="$emit('changeAccount')"
              :dataDimensionType="getFilterType"
              :datasource="getMediaCode"
              @search="handleSearchAccount"
              :accountList="accountList"
              :loading="loading"
              :isAccount="dataDimensionTypeName === '广告账号'"
            ></account-select>
          </a-form-item>
        <!-- </a-spin> -->
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import AccountSelect from "./accountSelect.vue"
import {
  getDataDimension,
  getTables
} from "@/api/basicCyberData";
import { mapGetters, mapState } from "vuex";

const dataDimensionOptions = [
  { value: "AD_ACCOUNT", name: "广告账号" },
  { value: "ADVERTISER_ID", name: "财务ID" },
  // { value: "CUSTOMER_CODE", name: "客户编码" },
  // { value: "PRODUCT_INFO", name: "产品信息" },
];
const afOptions = [
  { value: "AD_ACCOUNT", name: "产品信息" },
  { value: "ADVERTISER_ID", name: "财务ID" },
]
export default {
  name: "DataAuth",
  components: {
    AccountSelect,
  },
  props: ['dataSet', 'value', 'chartType'],
  data() {
    return {
      tableList: [],
      accountList: [],
      timeout: null,
      loading: false,
      data: {
        datasource: undefined,
        tableId: undefined,
        filterType: undefined,
        accountIds: [],
        collapseKey1: '1',
        collapseKey2: '1',
      }
    }
  },
  model: {
    prop: "value",
    event: "input",
  },
  watch: {
    value: {
      handler(val) {
        if(JSON.stringify(this.value) !== JSON.stringify(this.data)) {
          this.data = this.$deepclone(this.value);
          if(!this.tableList.length) {
            this.getTables()
          }
        }
      },
      deep: true,
      immediate: true
    },
    data: {
      handler(val) {
        this.$emit('input', this.data)
      },
      deep: true
    }
  },
  inject: ["getDashboardDynamicData"],
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
    }),
    dataDimensionOptions() {
      return this.data.datasource&&this.data.datasource.indexOf('AF') > -1&&this.data.datasource !== 'META-AF-TRIP'?afOptions:dataDimensionOptions
    },
    dataDimensionOptionsNew(){
      return this.userInfo.innerFlag === 1? this.dataDimensionOptions : this.dataDimensionOptions.slice(0, 1)
    },
    dataDimensionTypeName() {
      let findName = this.data.filterType ? this.dataDimensionOptions.find(item => item.value === this.data.filterType).name : '数据维度类型'
      return findName;
    },
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    getMediaCode(){
      return this.data.datasource || this.dashbordData?.datasource?.mediaCode
    },
    getFilterType(){
        return this.data.filterType || this.dashbordData?.filterType
    },
  },
  methods: {
    handleSearchAccount(val, orderAccountIds = []) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => {
        this.getAcccountList(val, orderAccountIds);
      }, 500);
    },
    async getAcccountList(keyWord, orderAccountIds) {
      this.accountList = [];
      if(!this.getFilterType) return;
      const params = {
        mediaCode: this.getMediaCode,
        authType: this.getFilterType
      };
      const dataParams = {
        filterEnable: true,
        searchKeyWord: keyWord,
        orderAccountIds,
      };
      try {
        this.loading = true
        const { code, data } = await getDataDimension(params, dataParams);
        this.loading = false
        let list = data.recordList || []
        if(this.getFilterType === 'ADVERTISER_ID') {
          list.forEach(e => {
            e.name = `${e.name}-${e.accountNum}个账号`
          });
        }
        this.accountList = list;
        if (code != 200) return;
      } catch (error) {
        this.accountList = [];
        this.loading = false
      }      
    },
    async changeDataSource() {
      // 在筛选器组件时，将全局的数据源和账户存储
      // 切换数据源时清空相关信息；
      this.data.tableId = undefined
      if(this.getFilterType !== 'ADVERTISER_ID') {
        this.data.filterType = this.data.datasource?'AD_ACCOUNT':undefined
        this.$emit('clearOthers')
        this.changeDataDimensionType()
      } else {
        this.data.tableId = undefined
      }
      this.getTables(true)
    },
    getTables(datachange) {
      this.tableList = []
      if(this.getMediaCode) {
        getTables(this.getMediaCode).then(res => {
          this.tableList = res.data || []
          if(datachange) {
            if(this.tableList.length === 1) {
              this.data.tableId = this.tableList[0].id
            }
            this.$emit('datachange')
          }
        })
      }
    },
    changeDataDimensionType(val){
      // 切换数据源时清空相关信息；
      this.data.accountIds = [];
      this.getAcccountList();
    }
  },
  mounted() {

  }
}
</script>